import { isomorRemote } from "isomor";
export enum ERR {
  missingGitHubConfig = 'Please authenticate to use GitHub api',
}